<template>
  <h3 class="mb-3">
    Moyenne de {{ statName }} de tous les coachs:
    {{ statAverage ? statAverage : 0 }}{{ percentage ? "%" : "" }}
    <el-popover
      v-if="tooltip"
      placement="top"
      width="500"
      trigger="hover"
      :content="tooltip"
    >
      <span slot="reference">
        <i class="fa fa-info-circle ml-05"></i>
      </span>
    </el-popover>
  </h3>
</template>

<script>
export default {
  props: {
    statName: {
      type: String,
      required: true,
    },

    statAverage: {
      type: String,
      required: true,
    },

    percentage: {
      type: Boolean,
      default: false,
    },

    tooltip: {
      type: String,
    },
  },
};
</script>
